export default "__VITE_ASSET__D9kAEau9__"